<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.crf version control") }}</h2>
    </div>
  </div>
  

  <div class="wrapper wrapper-content px-0">
    <!-- Filter Section -->
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group mb-1">
        <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
        <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
  <label class="mb-0">{{ $t("navigations.choose ecrf forms") }}</label>
  <select id="formSelect" class="form-control my-md-2 my-lg-0" v-model="formData.form">
    <option value="">{{ $t("navigations.select form") }}</option>
    <option
      v-for="template in sortedTemplates"
      :key="template.templateId"
      :value="template.templateId"
    >
      {{ template.templateName }}
    </option>
  </select>
</div>
        </div>
      </div>
    </div>

    <!-- Data Table Section -->
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5 class="mt-1">{{ $t("navigations.crf version list") }}</h5>
      </div>

      <div class="ibox-content">
        <div class="text-center" v-if="showTableLoading === true">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            alt="Loading"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>

        <template v-else>
          <div class="text-center" v-if="!formData.form">
            {{ $t("navigations.please select a form to manage crf versions") }}
          </div>

          <div class="text-center" v-else-if="sites.length === 0">
            {{ $t("navigations.no data available") }}
          </div>

          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th class="text-center" style="width: 5%">
                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @change="toggleSelectAll"
                       :disabled="allSelectableSites.length === 0"
                    />
                  </th>
                  <th style="width: 15%">{{ $t("navigations.site code") }}</th>
                  <th style="width: 20%">{{ $t("navigations.site name") }}</th>
                  <th style="width: 10%">{{ $t("navigations.current version") }}</th>
                  <th style="width: 10%">{{ $t("navigations.target version") }}</th>
                  <th style="width: 15%">{{ $t("navigations.transition rule") }}</th>
                  <th style="width: 15%">{{ $t("navigations.effective date") }}</th>
                  <th class="text-center" style="width: 10%">{{ $t("navigations.action") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(site, index) in paginatedSites" :key="site.siteId || index">
                  <td class="text-center">
                    <input
                      type="checkbox"
                      v-model="selectedSites"
                      :value="site"
                      :disabled="isSaveDisabled(site)"
                    />
                  </td>
                  <td>{{ site.sitecode || "" }}</td>
                  <td>{{ site.sitename || "" }}</td>
                  <td>{{ site.version || "" }}</td>
                    <td>{{ site.targetVersion || '' }}</td>
                  <td>
                    <select v-model="site.transitionRule" class="form-control py-0">
                      <option value="">
                        {{ $t("navigations.select rule") }}
                      </option>
                      <option value="Apply to New Subjects Only">{{ $t("navigations.apply to new Subjects only") }}</option>
                      <option value="Apply to All Subjects">{{ $t("navigations.apply to all subjects") }}</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="date"
                      class="form-control py-0"
                      v-model="site.effectiveDate"
                      

                    />
                    </td>
<td class="text-center position-relative">                    
  <i 
    class="fa fa-save editicon" 
    :class="{ 'disabled': isSaveDisabled(site) }" 
    @click="saveSingleSite(site)"
  ></i>
  <div class="tool-tip">{{ $t("navigations.save") }}</div>
</td>

                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="row mt-1 mx-0" v-if="sites.length > pageSize">
            <div class="col-lg-12 mx-0 px-0">
              <div
                class="dataTables_paginate paging_simple_numbers pagination float-right"
              >
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <VPagination
                    v-model="currentPage"
                    :pages="totalItems"
                    :range-size="1"
                    active-color="#ededed"
                    @update:modelValue="loadPage"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="col-lg-12 my-3 d-flex justify-content-lg-end px-0">
            <button class="save_btn py-1 px-4" type="submit" @click.prevent="applyAllSelected" :disabled="isSaveAllDisabled" >
              <span v-if="showLoading">
                <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
              </span>
              <span v-else>
                {{ $t("navigations.save all") }}
              </span>
            </button>
          </div>
          </template>
      </div>
      
    </div>
  </div>
</template>

<script src="./CRFversionControl.js"></script>

<style scoped>
.data-grid {
  margin-top: 20px;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.position-relative img {
  width: 20px;
}
.position-relative {
  position: relative;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
    visibility: visible;
    -webkit-transition: visibility 30ms ease-in;
    transition: visibility 30ms ease-in;
}

.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.3rem 0.8rem;
  right: 0;
  top: -20px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
.scrollable {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 500px;
  background-color: #ffffff;
}
.errormsg {
  color: red;
  font-size: 12px;
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}
.ml-2 {
  margin-left: 0.5rem;
}
.td {
    line-height: 1.0;
    padding: 2px 4px;    
}
.editicon.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>